module.exports = __webpack_public_path__ + "static/media/ICBT 3a3.aa4f5843.jpg";